type Props = {
  fill: string;
  height: string;
  width: string;
};

const HandlingCoinsIcon = ({ height, width, fill }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_5642_17168)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.5 2C13.7761 2 14 1.77614 14 1.5C14 1.22386 13.7761 1 13.5 1C13.2239 1 13 1.22386 13 1.5C13 1.77614 13.2239 2 13.5 2ZM13.5 3C14.3284 3 15 2.32843 15 1.5C15 0.671573 14.3284 0 13.5 0C12.6716 0 12 0.671573 12 1.5C12 2.32843 12.6716 3 13.5 3ZM10 7.5C10 8.05228 9.55228 8.5 9 8.5C8.44772 8.5 8 8.05228 8 7.5C8 6.94772 8.44772 6.5 9 6.5C9.55228 6.5 10 6.94772 10 7.5ZM11 7.5C11 8.60457 10.1046 9.5 9 9.5C7.89543 9.5 7 8.60457 7 7.5C7 6.39543 7.89543 5.5 9 5.5C10.1046 5.5 11 6.39543 11 7.5ZM13.2718 11.76L13.2903 11.7458L14.3735 10.9126C14.558 10.7707 14.6088 10.5141 14.4924 10.3127C14.361 10.0853 14.0674 10.0121 13.8447 10.1513L10.1686 12.4489C9.36728 12.9497 8.36388 12.5364 8.07878 11.7192L6.45761 11.3035C6.08508 11.208 5.69292 11.2219 5.3281 11.3436L3 12.12V13.4497V14.5H9.66738C9.9039 14.5 10.1328 14.4162 10.3133 14.2634L13.2541 11.7751L13.2718 11.76ZM5.01172 10.395L3 11.0659V11C3 10.4477 2.55228 9.99999 2 9.99999H1C0.447715 9.99999 0 10.4477 0 11V15C0 15.5523 0.447715 16 1 16H2C2.37014 16 2.69331 15.7989 2.86621 15.5H3H9.66738C10.1404 15.5 10.5982 15.3323 10.9593 15.0268L13.9 12.5385L14.9832 11.7052C15.5652 11.2575 15.7256 10.4481 15.3583 9.81238C14.9438 9.09505 14.0172 8.86423 13.3147 9.30331L9.63859 11.6009C9.3606 11.7746 9 11.5748 9 11.2469C9 11.0564 8.8709 10.89 8.68629 10.8426L6.70599 10.3349C6.1472 10.1916 5.55895 10.2125 5.01172 10.395ZM2 14.5V15H1L1 11H2V11.3994V13.4497V14.5ZM4 3.5C4 3.77614 3.77614 4 3.5 4C3.22386 4 3 3.77614 3 3.5C3 3.22386 3.22386 3 3.5 3C3.77614 3 4 3.22386 4 3.5ZM5 3.5C5 4.32843 4.32843 5 3.5 5C2.67157 5 2 4.32843 2 3.5C2 2.67157 2.67157 2 3.5 2C4.32843 2 5 2.67157 5 3.5ZM7.5 3H8.5V5H7.5V3ZM10.5 2H9.5V4H10.5V2ZM7.5 1H8.5V2H7.5V1ZM10.5 0H9.5V1H10.5V0ZM4 6V7H3V6H4ZM14 4H13V5H14V4ZM4 8V9H3V8H4ZM14 6H13V7H14V6Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_5642_17168">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default HandlingCoinsIcon;
